import React, { useEffect, useState } from 'react';
import brand from '../config/brand';

export default function ResumeQuote() {
  const [token] = useState(() => {
    const value = window.location.hash.slice(1);
    window.history.replaceState(null, '', '/r');
    return value;
  });
  const [error, setError] = useState('');
  useEffect(() => {
    async function restore() {
      try {
        const response = await fetch('/api/resume', { method: 'POST',
          headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token }) });
        const result = await response.json();
        if (!response.ok || !result.form) throw new Error('unavailable');
        const form = result.form;
        sessionStorage.setItem('quote_resume_form', JSON.stringify({ form, expires: Date.now() + 3600000 }));
        // Seed before mounting Statsig. Existing experiments evaluate the same
        // stable identity on the new device, including retired-arm fallbacks.
        const stable = form.statsig_stable_id;
        if (typeof stable === 'string' && /^[A-Za-z0-9_.-]{1,128}$/.test(stable)) {
          document.cookie = `_cabana_sid=${stable}; domain=.${brand.siteOrigin}; path=/; max-age=31536000; SameSite=Lax; Secure`;
          localStorage.setItem('_cabana_sid', stable);
        }
        localStorage.removeItem('redirectFirstStep');
        window.location.replace('/step/1');
      } catch { setError('We could not open this saved request. Reopen your link or call us for help.'); }
    }
    restore();
  }, [token]);
  return <main className="container" style={{ maxWidth: 480, padding: '48px 24px' }}>
    {error ? <>
      <h1>We could not open your quote</h1>
      <p role="alert">{error}</p>
      <p><a href={`tel:${brand.phone.replace(/[^+0-9]/g, '')}`}>Call {brand.phone}</a></p>
    </> : <p role="status">Opening your saved quote...</p>}
  </main>;
}
